import { gql } from 'graphql-request'

export namespace SourceQueries {
  export namespace GET_SOURCES {
    export type Response = { potentialBookingSources: Source[] | null }
  }
  export function getSources() {
    return gql`
      query getSources($filter: PotentialBookingSourceFilter = { active: true }) {
        potentialBookingSources(filter: $filter) {
          id
          description
          manualChangeAllowed
        }
      }
    `
  }
}

export interface Source {
  description: string
  id: number
  manualChangeAllowed?: boolean
}
